import { collectionEngineV1 } from '../apis.js';
const req = collectionEngineV1('/voucher-applications');
export const create = async (tenantId, application) => req('POST', `/`, {
    body: application,
});
export const getAll = async (tenantId) => req('GET', `/`);
export const update = async (tenantId, applicationId, application) => req('PATCH', `/${applicationId}`, {
    body: application,
});
//# sourceMappingURL=voucher-applications.js.map